import { render, staticRenderFns } from "./SectionListTemplate.vue?vue&type=template&id=6415a316&"
import script from "./SectionListTemplate.vue?vue&type=script&lang=js&"
export * from "./SectionListTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports